import styled from 'styled-components'
import { StickyContainer } from 'react-sticky'

export const ResponsiveCard = styled.div`
  padding-bottom: 40px;
  padding-top: 40px;
  border: 1px solid rgb(227, 230, 232);
  border-radius: 6px;

  /* Mobile view - 24px padding left and right */
  padding-left: 24px;
  padding-right: 24px;

  /* Larger screens - 32px padding left and right */
  @media screen and (min-width: 768px) {
    padding-left: 32px;
    padding-right: 32px;
  }
`
export const FlexContainerLimitWidth = styled.div`
  max-width: none;
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;
  flex-direction: column;

  @media screen and (min-width: 992px) {
    max-width: 1200px;
  }
`

export const StyledStickyContainer = styled(StickyContainer)`
  height: 100%;
`

export const StyledStickyItem = styled.div`
  ${({ isSticky }) =>
    isSticky &&
    `
    @media screen and (min-width: 769px) {
      margin-top: 0px;
      transition: margin-top 0.3s;
    }
  `}
`

export const StyledHeadingContainer = styled.div`
  @media screen and (max-width: 992px) {
    padding-bottom: 1.5rem;
    padding-top: 2rem;
  }
  @media screen and (min-width: 992px) {
    padding-bottom: 2rem;
    padding-top: 48px;
  }
`
